import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  showHeat?: boolean;
}

function formatHeat(heat: number) {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)}万`;
  }
  return String(heat);
}

export default function MovieCard({ movie, showHeat = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:ring-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-secondary-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 伊人在线影视`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-600/90 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          {movie.type}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-black/55 px-2 py-0.5 text-xs font-semibold text-accent-400 backdrop-blur-sm">
          <i className="ri-star-fill text-[11px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        {showHeat && (
          <span className="absolute bottom-2 left-2 flex items-center gap-1 rounded-full bg-accent-500/95 px-2.5 py-0.5 text-xs font-semibold text-accent-950">
            <i className="ri-fire-fill text-[11px]"></i>
            {formatHeat(movie.heat)}
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-600 md:text-sm">
          {movie.genres.join(' · ')}
        </p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="truncate">{movie.region}</span>
        </div>
      </div>
    </Link>
  );
}